// Initial data for the portfolio.
// In a real app, this would come from a backend or Firebase.
// Here we load it from localStorage if it exists, otherwise we use this default data.

const defaultData = {
  expertise: [
    {
      id: '1',
      iconType: 'code',
      title: 'Web Development',
      desc: 'Building scalable, high-performance web applications using the latest modern stacks.',
    },
    {
      id: '4',
      iconType: 'code',
      title: 'App Development',
      desc: 'Building scalable, high-performance mobile applications using the latest modern stacks.',
    },
    {
      id: '5',
      iconType: 'trend',
      title: 'Shopify Development',
      desc: 'Building custom Shopify storefronts and themes for seamless e-commerce experiences.',
    },
    {
      id: '6',
      iconType: 'users',
      title: 'Social Media Marketing',
      desc: 'Driving brand growth and engagement through targeted social media campaigns.',
    },
    {
      id: '2',
      iconType: 'pen',
      title: 'UI/UX Design',
      desc: 'Designing intuitive user interfaces that convert visitors into loyal customers.',
    },
    {
      id: '3',
      iconType: 'brand',
      title: 'Video Editing',
      desc: "Creating cohesive visuals that tell your brand's unique story effectively.",
    }
  ],
  services: [
    {
      id: '1',
      iconType: 'code',
      title: 'Web Development',
      desc: 'I build modern, responsive, and high-performance websites tailored to your goals. From landing pages to full business websites, every build is optimized for speed, usability, and long-term scalability.',
      features: [
        'React & Next.js Development', 'Responsive UI for All Devices',
        'API Integration', 'Performance Optimization',
      ],
      visual: 'web',
    },
    {
      id: '2',
      iconType: 'code',
      title: 'App Development',
      desc: 'Creating robust and scalable mobile applications using modern frameworks. Providing seamless experiences across both iOS and Android platforms.',
      features: [
        'React Native Development', 'Cross-Platform Compatibility',
        'Intuitive Mobile UX', 'API & Backend Integration',
      ],
      visual: 'app',
    },
    {
      id: '3',
      iconType: 'trend',
      title: 'Shopify Development',
      desc: 'I create powerful E-commerce solutions using Shopify, ensuring a smooth and highly converting shopping experience for your customers.',
      features: [
        'Custom Shopify Themes', 'App Integrations',
        'Store Optimization', 'Conversion Rate Focus'
      ],
      visual: 'shopify',
    },
    {
      id: '4',
      iconType: 'users',
      title: 'Social Media Marketing',
      desc: 'I craft data-driven social media strategies to boost your online presence and engage with your target audience effectively.',
      features: [
        'Campaign Management', 'Audience Targeting',
        'Analytics & Reporting', 'Brand Awareness'
      ],
      visual: 'marketing',
    },
    {
      id: '5',
      iconType: 'pen',
      title: 'UI/UX Design',
      desc: 'I design interfaces that are clean, user-friendly, and conversion-focused. My process combines visual consistency with practical user flows.',
      features: [
        'Wireframes & Prototypes', 'Brand-Aligned UI Design',
        'Design Systems', 'Mobile-First Layouts',
      ],
      visual: 'design',
    },
    {
      id: '6',
      iconType: 'brand',
      title: 'Video Editing',
      desc: 'I help improve your digital visibility through engaging visual media support to strengthen your brand presence and tell your story.',
      features: [
        'Promotional Video Editing', 'Social Media Reels',
        'Color Grading & Effects', 'Audio Sync & Mixing',
      ],
      visual: 'video',
    }
  ],
  projects: [
    {
      id: 7,
      title: 'MedicAssist',
      tags: ['MERN STACK', 'FASTAPI', 'AI INTEGRATION', 'HEALTHTECH'],
      desc: 'An AI-powered hospital management platform integrated with a FastAPI backend to deliver online disease checkups. Built on the MERN stack, it features secure role-based portals for patients, doctors, and admins to seamlessly manage medical appointments, digital health records, and real-time hospital workflows.',
      link: 'https://medicassist-auj8.onrender.com',
      image: '/images/project7.png',
      gradient: 'linear-gradient(135deg, #22d3ee 0%, #0369a1 100%)',
    },
    {
      id: 8,
      title: 'UniCore System',
      tags: ['MERN STACK', 'REACT', 'MANAGEMENT'],
      desc: 'A comprehensive, three-role university complaint management system designed to streamline communication across campus. The platform allows students, faculty, and administration to log, track, and resolve department-specific grievances—ranging from hostel issues to academic and administrative complaints.',
      link: 'https://unicore-system.onrender.com/',
      image: '/images/project8.png',
      gradient: 'linear-gradient(135deg, #f43f5e 0%, #881337 100%)',
    },
    {
      id: 3,
      title: 'Personalized Portfolio',
      tags: ['UI/UX', 'Figma', 'Design','React','Tailwind CSS'],
      desc: 'Custom portfolio design and development for a creative professional, featuring custom illustrations and animations.',
      link: 'https://faheemkhangraphics.com/',
      image: '/images/project3.png',
      gradient: 'linear-gradient(135deg, #1e1b4b 0%, #312e81 100%)',
    },
    {
      id: 5,
      title: 'E-commerce Website Design',
      tags: ['UI/UX', 'E-Commerce Design','React','Bootstrap'],
      desc: 'Designed and developed a modern e-commerce website with intuitive navigation, product showcases, and seamless checkout experience.',
      link: 'https://velleur-fashion.netlify.app/',
      image: '/images/project5.png',
      gradient: 'linear-gradient(135deg, #450a0a 0%, #7f1d1d 100%)',
    },
    {
      id: 1,
      title: 'Portfolio Website',
      tags: ['React', 'TypeScript', 'Tailwind CSS'],
      desc: 'Custom portfolio site with interactive UI, dark mode, and responsive design.',
      link: 'https://dev-portfolio-developer.netlify.app/',
      image: '/images/project1.png',
      gradient: 'linear-gradient(135deg, #0ea5e9 0%, #0d9488 100%)',
    },
    {
      id: 2,
      title: ' Education Platform',
      tags: ['React.js', 'Tailwind CSS'],
      desc: 'Online learning platform with digital products repair documentation, video tutorials and interactive exercises.',
      link: 'https://maramat-repair.netlify.app/',
      image: '/images/project2.png',
      gradient: 'linear-gradient(135deg, #e5e7eb 0%, #f9fafb 100%)',
      dark: true,
    },
    {
      id: 4,
      title: 'Personal Portfolio',
      tags: ['React', 'Bootstrap'],
      desc: 'A sleek portfolio website built with React and Bootstrap, showcasing projects with smooth animations and responsive design.',
      link: 'https://talha-portfolio-web.vercel.app/',
      image: '/images/project4.png',
      gradient: 'linear-gradient(135deg, #14532d 0%, #166534 100%)',
    },
    {
      id: 6,
      title: 'Hospital Management Website',
      tags: ['Web', 'React.js', 'Tailwind CSS'],
      desc: 'A hospital management website with features for patient registration, appointment scheduling, and medical record management.',
      link: 'https://healthconnect-website.netlify.app/login',
      image: '/images/project6.png',
      gradient: 'linear-gradient(135deg, #2e1065 0%, #5b21b6 100%)',
    }
  ],
  experience: [
    { id: '1', date: '20 Feb 2026 — Current', role: 'MERN Developer @ IT Verse Solutions', desc: 'Working on full-stack MERN applications with focus on scalable architecture, clean APIs, and responsive frontend delivery.' },
    { id: '2', date: 'July 2025 — Sep 2025', role: 'Frontend Intern @ IT Verse Solutions', desc: 'Completed internship in frontend development, building responsive interfaces and assisting in real client web projects.' },
    { id: '3', date: '2024 — Current', role: 'Freelance Video Editor', desc: 'Providing freelance video editing services for social media content, promotional campaigns, and storytelling-focused digital media.' },
  ],
  skills: [
    { id: '1', iconType: 'arch', name: 'Web Development', desc: 'Building modern, responsive, and high-performance websites using scalable architecture.' },
    { id: '3', iconType: 'users', name: 'App Development', desc: 'Creating reliable cross-platform app experiences with a user-first development process.' },
    { id: '5', iconType: 'trend', name: 'Shopify Development', desc: 'Building custom Shopify storefronts and themes for seamless e-commerce experiences.' },
    { id: '6', iconType: 'motion', name: 'Social Media Marketing', desc: 'Driving brand growth and engagement through targeted social media campaigns.' },
  ],
  cvLink: '/Talha_Khalid_CV.pdf'
};

export const getPortfolioData = () => {
  const saved = localStorage.getItem('portfolioData');
  if (saved) {
    try {
      return JSON.parse(saved);
    } catch (e) {
      return defaultData;
    }
  }
  return defaultData;
};

export const savePortfolioData = (data) => {
  localStorage.setItem('portfolioData', JSON.stringify(data));
};
